import React, {useEffect, useRef, useState} from "react";
import {SearchQuicklinks} from "../types/searchQuicklinks";
import {Quicklinks} from "../components/Quicklinks";
import {Input} from "../components/Input";
import {SearchResult} from "../types/searchResult";
import {useDebounce} from "use-debounce";
import {getAllSearchBoxResults} from "../service/api";
import {SearchSuggestions} from "../components/SearchSuggestions";
import {SearchCompletions} from "../components/SearchCompletions";
import {useMediaQuery} from "react-responsive";
import {useTranslation} from "../hooks/useTranslation";

type SearchProps = {
    searchResultLink: string,
    searchQuicklinks: SearchQuicklinks[]
}

function Search({searchResultLink, searchQuicklinks}: SearchProps) {

    const [searchResultsItems, setSearchResultsItems] = useState<SearchResult[]>([])
    const [searchInput, setSearchInput] = useState<string>('');
    const [openSearchResults, setOpenSearchResults] = useState<boolean>(false);

    const [debouncedSearch] = useDebounce<string>(searchInput, 250);
    const isMobile = useMediaQuery({ query: '(max-width: 992px)' });
    const overlay = useRef<HTMLDivElement>(null);

    const translate = useTranslation();

    useEffect(()=> {
        if(debouncedSearch) {
            getAllSearchBoxResults(debouncedSearch).then(response => {
                setSearchResultsItems(response.items);
            });
        } else {
            setSearchResultsItems([])
        }

    }, [debouncedSearch]);

    const showResults = () => {
        window.location.href = searchInput ? (searchResultLink + '?search=' + searchInput) : searchResultLink;
    };

    useEffect(() => {
        const globalClickHandler: EventListener = (event) => {
            if (overlay.current !== null) {
                const clickedElement = event.target as Element;

                if (overlay.current !== clickedElement && !overlay.current.contains(clickedElement)) {
                    setOpenSearchResults(false)
                }
            }
        }

        window.addEventListener('click', globalClickHandler);

        return () => window.removeEventListener('click', globalClickHandler);
    }, [openSearchResults])

    return (
        <div className="search" ref={overlay}>
            <Input
                searchInput={searchInput}
                updateSearchInput={setSearchInput}
                placeholder={translate('search.input.placeholder')}
                showResults={showResults}
                ariaLabel={translate('search.input.ari.label')}
                searchBtnAriaLabel={translate('search.input.btn.label')}
                setOpenSearchResults={setOpenSearchResults}
            />

            {openSearchResults &&
                <div className={'search__resultWrapper'}>
                    {!debouncedSearch &&
                        <Quicklinks searchQuicklinks={searchQuicklinks}/>
                    }

                    {debouncedSearch &&
                        <div className='row search__result_row'>
                            <SearchCompletions searchResultLink={searchResultLink} searchText={debouncedSearch} />

                            {!isMobile &&
                                <SearchSuggestions searchText={debouncedSearch} searchResultLink={searchResultLink}/>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default Search;